import React from "react"
import Layout from "../components/layout"
import Slider from "../components/Slider"
import ArticleCard from "../components/ArticleCard"
import FadeIn from "../components/FadeIn"
import Img from "gatsby-image"
import classnames from "classnames"
import { graphql } from "gatsby"
import Seo from "../components/seo"

import("../styles/page-blog-post.scss")

export default ({ pageContext, data }) => {
  let featureImage =
    pageContext.featuredImage.node.slug !== "default-article-image"
      ? pageContext.featuredImage.node.localFile.childImageSharp.fluid
      : null
  const image =
    featureImage !== null ? (
      <FadeIn>
        <Img className="featuredImage" fluid={featureImage} />
      </FadeIn>
    ) : null
  const slides = data.allWpPost.edges.map(post => (
    <ArticleCard
      categories={post.node.categories}
      key={post.node.title}
      title={post.node.title}
      image={post.node.featuredImage.node.localFile.childImageSharp.fluid}
      slug={post.node.slug}
    />
  ))
  return (
    <Layout marginTop={true} className="blogPage">
      <Seo title={pageContext.title} description={pageContext.excerpt} />
      <article
        className={classnames({
          blogPost: true,
          noImage: featureImage === null,
        })}
      >
        <FadeIn>
          <h1
            className="secondTitle"
            dangerouslySetInnerHTML={{ __html: pageContext.title }}
          />
        </FadeIn>
        <FadeIn>
          <h4
            className="date"
            dangerouslySetInnerHTML={{ __html: pageContext.date }}
          />
        </FadeIn>
        {image}
        <FadeIn threshold="0">
          <div
            className="blogContent"
            dangerouslySetInnerHTML={{ __html: pageContext.content }}
          />
        </FadeIn>
      </article>
      <div className="blogSlider">
        <FadeIn>
          <h3 className="secondTitle">Featured Articles</h3>
        </FadeIn>
        <Slider removeOnMobile={true} slides={slides} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allWpPost(
      limit: 3
      filter: {
        categories: { nodes: { elemMatch: { slug: { eq: "featured" } } } }
      }
    ) {
      edges {
        node {
          categories {
            nodes {
              slug
              id
            }
          }
          slug
          title
          featuredImage {
            node {
              slug
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
